import React, { useState } from 'react';
import { skillsData } from '../data/skills';
import './Skills.css';

const Skills = () => {
  const data = skillsData;
  const [showAll, setShowAll] = useState(false);

  // Flatten all skills from all categories
  const allSkills = data.categories.flatMap(category => category.skills);
  const displayedSkills = showAll ? allSkills : allSkills.slice(0, 12);

  // Fallback logo colors and initials (used if PNG not found)
  const getTechLogoFallback = (name) => {
    const techLogos = {
      'AWS': { color: '#FF9900', svg: 'AWS', bg: '#232F3E' },
      'Azure': { color: '#0078D4', svg: 'AZ', bg: '#0078D4' },
      'GCP': { color: '#4285F4', svg: 'GCP', bg: '#4285F4' },
      'Docker': { color: '#2496ED', svg: 'D', bg: '#2496ED' },
      'Kubernetes': { color: '#326CE5', svg: 'K', bg: '#326CE5' },
      'Terraform': { color: '#623CE4', svg: 'T', bg: '#623CE4' },
      'Ansible': { color: '#EE0000', svg: 'A', bg: '#EE0000' },
      'Jenkins': { color: '#D24939', svg: 'J', bg: '#D24939' },
      'Git': { color: '#F05032', svg: 'G', bg: '#F05032' },
      'Python': { color: '#3776AB', svg: 'Py', bg: '#3776AB' },
      'GitHub': { color: '#181717', svg: 'GH', bg: '#181717' },
      'GitLab': { color: '#FC6D26', svg: 'GL', bg: '#FC6D26' },
      'Helm': { color: '#0F1689', svg: 'H', bg: '#0F1689' },
      'Prometheus': { color: '#E6522C', svg: 'P', bg: '#E6522C' },
      'Grafana': { color: '#F46800', svg: 'G', bg: '#F46800' },
    };

    // Try to find matching tech
    const match = Object.keys(techLogos).find(key => 
      name.toLowerCase().includes(key.toLowerCase())
    );
    
    if (match) {
      return techLogos[match];
    }
    
    // Default fallback
    const defaultColors = ['#667eea', '#764ba2', '#f093fb', '#4facfe', '#00f2fe'];
    const colorIndex = name.charCodeAt(0) % defaultColors.length;
    return {
      color: defaultColors[colorIndex],
      svg: name.substring(0, 2).toUpperCase(),
      bg: defaultColors[colorIndex]
    };
  };

  return (
    <section id="skills" className="skills-section">
      <div className="section-heading fade-in-up">
        <h2>Technical Skills</h2>
        <p>A curated selection of my expertise in DevOps and Cloud Computing</p>
      </div>
      <div className="skills-grid fade-in-up">
        {displayedSkills.map((skill, idx) => {
          const fallback = getTechLogoFallback(skill.name);
          const logoPath = skill.logo ? `/logos/${skill.logo}` : null;
          
          return (
            <div key={idx} className="skill-card">
              <div 
                className="skill-icon"
                style={{ 
                  background: logoPath ? 'transparent' : fallback.bg,
                  color: logoPath ? 'transparent' : 'white'
                }}
              >
                {logoPath ? (
                  <img 
                    src={logoPath} 
                    alt={skill.name}
                    className="skill-logo-img"
                    onError={(e) => {
                      // Fallback to colored icon if image fails to load
                      e.target.style.display = 'none';
                      e.target.parentElement.style.background = fallback.bg;
                      e.target.parentElement.style.color = 'white';
                      e.target.parentElement.textContent = fallback.svg;
                    }}
                  />
                ) : (
                  fallback.svg
                )}
              </div>
              <div className="skill-name-card">{skill.name}</div>
            </div>
          );
        })}
      </div>
      {allSkills.length > 12 && (
        <div className="skills-actions fade-in-up">
          <button 
            className="btn btn-primary show-all-btn"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? 'Show Less' : `Show All (${allSkills.length})`}
          </button>
        </div>
      )}
      <p className="skills-footer fade-in-up">
        ...and plenty more technologies I'm exploring & mastering every day.
      </p>
    </section>
  );
};

export default Skills;

